// Opening a mental object on its page (My Workspace → Mental Models, model
// selected) from anywhere. MyWorkspace consumes these when the Models tab
// opens (same contract MmLiftMenuItem and TraitDetailPanel already use for
// mm_open_object). A staged path — or `visit` — lands the page on its
// "what brings you here?" step, ready to start a visit with that path.

export const MM_OPEN_OBJECT_KEY = "mm_open_object";
export const MM_OPEN_PATH_KEY = "mm_open_path";
export const MM_OPEN_VISIT_KEY = "mm_open_visit";

export function stageMmOpen(objectId: string, pathId?: string, opts?: { visit?: boolean }): void {
  try {
    sessionStorage.setItem(MM_OPEN_OBJECT_KEY, objectId);
    if (pathId) sessionStorage.setItem(MM_OPEN_PATH_KEY, pathId);
    else sessionStorage.removeItem(MM_OPEN_PATH_KEY);
    if (opts?.visit) sessionStorage.setItem(MM_OPEN_VISIT_KEY, "1");
    else sessionStorage.removeItem(MM_OPEN_VISIT_KEY);
    localStorage.setItem("workspace_active_tab", "mental_models");
    localStorage.setItem("portal_active_tab", "my_workspace");
  } catch {
    /* storage blocked: the portal still opens, just not on the object */
  }
}

/** Read and clear the staged path (one use). */
export function takeMmOpenPath(): string | undefined {
  try {
    const path = sessionStorage.getItem(MM_OPEN_PATH_KEY);
    sessionStorage.removeItem(MM_OPEN_PATH_KEY);
    return path || undefined;
  } catch {
    return undefined;
  }
}

export interface MmOpenRequest {
  id: string;
  pathId?: string;
  /** Land on the visit step (a staged path implies it). */
  visit: boolean;
}

/** The staged open, without consuming it (safe in a render initializer). */
export function readMmOpen(): MmOpenRequest | null {
  try {
    const id = sessionStorage.getItem(MM_OPEN_OBJECT_KEY);
    if (!id) return null;
    const pathId = sessionStorage.getItem(MM_OPEN_PATH_KEY) || undefined;
    const visit = sessionStorage.getItem(MM_OPEN_VISIT_KEY) === "1";
    return { id, pathId, visit: visit || !!pathId };
  } catch {
    return null;
  }
}

export function clearMmOpen(): void {
  try {
    sessionStorage.removeItem(MM_OPEN_OBJECT_KEY);
    sessionStorage.removeItem(MM_OPEN_PATH_KEY);
    sessionStorage.removeItem(MM_OPEN_VISIT_KEY);
  } catch {
    /* nothing staged */
  }
}

/** Read and clear the whole staged open (one use). */
export function takeMmOpen(): MmOpenRequest | null {
  const req = readMmOpen();
  clearMmOpen();
  return req;
}
